import request from 'local_modules/request'
import actions from 'redux/actions'
import { constants, modals } from 'helpers'
import { reducers, getState } from 'redux/core'



const setFetching = (isFetching) => reducers.marketplace.customerOrderFoodPage.setFetching(isFetching)

const fetchSchoolStages = () => {
  const { // TODO rework repetitions
    marketplace: {
      layersNavigation: {
        category: selectedCategory, area: selectedArea,
      },
    },
  } = getState()
  
  const isRpc = selectedCategory === 'rpc'
  const prefix = isRpc ? constants.rpc : constants.edu
  return request.get(prefix.schoolStages)
    .then(({ data }) => data)
    .then((schoolStages) => {
      reducers.marketplace.customerOrderFoodPage.setSchoolStages(schoolStages)
    })
    .catch((error) => {
      console.log(error)
    })
}

const fetchCategories = () => {
  const {
    marketplace: {
      layersNavigation: {
        category: selectedCategory, area: selectedArea,
      },
    },
  } = getState()
  
  const isRpc = selectedCategory === 'rpc'
  const url = isRpc ? constants.rpc.categories : constants.edu.categories
  const { marketplace: { layersNavigation: { toolType } } } = getState()

  return request.get(url + `/${toolType}?all=false`)
    .then(({ data }) => data)
    .then((categories) => {
      reducers.marketplace.customerOrderFoodPage.setCategories(categories)
    })
    .catch((error) => {
      console.log(error)
    })
}

const fetchSchools = () => {
  const {
    marketplace: {
      layersNavigation: {
        category: selectedCategory, area: selectedArea,
      },
    },
  } = getState()
  
  const isRpc = selectedCategory === 'rpc'
  const prefix = isRpc ? constants.rpc : constants.edu
  return request.get(prefix.schools + `?all=false`)
    .then(({ data }) => data)
    .then((schools) => {
      if (schools && schools.length) {
        return schools.sort((a, b) => {
          const titleA = parseInt(a.title.replace(/\(.*/, '').replace(/.*№/, ''), 10)
          const titleB = parseInt(b.title.replace(/\(.*/, '').replace(/.*№/, ''), 10)

          if (titleA === titleB) {
            return a.title < b.title ? -1 : a.title > b.title ? 1 : 0
          }

          return titleA < titleB ? -1 : titleA > titleB ? 1 : 0
        })
      }

      return schools
    })
    .then((schools) => {
      reducers.marketplace.customerOrderFoodPage.setSchools(schools)

      return schools
    })
    .catch((error) => {
      console.log(error)
    })
}

const fetchClasses = (schoolId) => {
  const {
    marketplace: {
      layersNavigation: {
        category: selectedCategory, area: selectedArea,
      },
    },
  } = getState()
  
  const isRpc = selectedCategory === 'rpc'
  const prefix = isRpc ? constants.rpc : constants.edu
  // const { marketplace: { layersNavigation: { toolType } } } = getState()

  return request.get(prefix.schools + `/${schoolId}?all=false`)
    .then(({ data }) => data)
    .then((classes) => {
      reducers.marketplace.customerOrderFoodPage.setClasses({ schoolId, classes })
    })
    .catch((error) => {
      console.log(error)
    })
}

const fetchDates = () => {
  const {
    marketplace: {
      layersNavigation: {
        category: selectedCategory, area: selectedArea,
      },
    },
  } = getState()
  
  const isRpc = selectedCategory === 'rpc'
  const prefix = isRpc ? constants.rpc : constants.edu
  // const { marketplace: { layersNavigation: { toolType } } } = getState()

  // return request.get(prefix.dates + `/${toolType}?all=true`)
  return request.get(prefix.datesAvailable)
    .then(({ data }) => data)
    .then((dates) => {
      reducers.marketplace.customerOrderFoodPage.setDates(dates)
    })
    .catch((error) => {
      console.log(error)
    })
}

// orderTotal: '/order/food/total', // { order: [ { dayInt, items: [ id, count ] } ] }
const fetchTotal = (order) => {
  const {
    marketplace: {
      layersNavigation: {
        category: selectedCategory, area: selectedArea,
      },
    },
  } = getState()
  
  const isRpc = selectedCategory === 'rpc'
  const prefix = isRpc ? constants.rpc : constants.edu
  reducers.marketplace.customerOrderFoodPage.setTotalFetching(true)

  return request.post(prefix.orderTotal, { order })
    .then(({ data }) => data)
    .then(({ total, errormsg }) => {
      if (typeof total === 'object') {
        console.error(errormsg)
      }
      else {
        reducers.marketplace.customerOrderFoodPage.setTotal(total)
      }

      reducers.marketplace.customerOrderFoodPage.setTotalFetching(false)
    })
}

// orderCreate: '/order/food/create',
const createOrder = ({ subscriber, order }) => {
  const {
    marketplace: {
      layersNavigation: {
        category: selectedCategory, area: selectedArea,
      },
    },
  } = getState()
  
  const isRpc = selectedCategory === 'rpc'
  const prefix = isRpc ? constants.rpc : constants.edu
  actions.ui.showRequestLoader('Не закрывайте окно, ваш запрос на оплату обрабатывается')

  return request.post(prefix.orderCreate, { order, subscriber })
    .then(({ data }) => data)
    .then(({ status, errormsg, redirectUrl }) => {
      if (errormsg) {
        actions.ui.hideRequestLoader()
        actions.modals.open(modals.Dialog, {
          title: 'Оплата не прошла',
          text: errormsg,
        })
      }
      else if (redirectUrl) {
        window.location.href = redirectUrl
      }
      else {
        console.log(data)
        actions.ui.hideRequestLoader()
      }

      return data
    })
}

// orderCancel: '/order/food/cancel',
// orderData: '/order/food',


export default {
  setFetching,
  fetchDates,
  fetchSchools,
  fetchClasses,
  fetchCategories,
  fetchSchoolStages,

  fetchTotal,
  createOrder,
}
